import { decode } from 'html-entities';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { sanitizeHTML } from '../../utilities';

const MessageWolframAlpha = ({ text, image, question }) => {
  const { t } = useTranslation();

  return (
    <Root>
      <p>{t('wolframAlphaMessage')}</p>
      <Content>
        <p
          dangerouslySetInnerHTML={{
            __html: sanitizeHTML(text)
          }}
        />
        {!isEmpty(image) && <img src={decode(image.attr_src)} alt={image.alt} />}
      </Content>
      <LinkContent>
        {t('source')}:{' '}
        <a
          href={`http://www.wolframalpha.com/input/?i=${question}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Wolfram | Alpha
        </a>
      </LinkContent>
    </Root>
  );
};

MessageWolframAlpha.propTypes = {
  text: PropTypes.string.isRequired,
  image: PropTypes.shape({
    attr_src: PropTypes.string,
    alt: PropTypes.string
  }),
  question: PropTypes.string.isRequired
};

MessageWolframAlpha.default = {
  image: {}
};

const Root = styled.div``;

const Content = styled.div`
  margin: 6px 0 8px;
  img {
    width: auto !important;
    max-width: 360px;
    margin-top: 4px !important;
  }
`;

const LinkContent = styled.p`
  font-style: italic;
`;

export default MessageWolframAlpha;
